// ModalAddBeforeLawsuitforProvince
import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  List,
  Modal,
  Row,
  Table,
  notification,
} from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { POST_ADD_ASSETTHASLOAN } from "../../../API/apiUrls";
import { CaretRightOutlined } from "@ant-design/icons";
import Title from "antd/es/skeleton/Title";

const { Panel } = Collapse;

function ModalAddBeforeLawsuitforProvince({
  open,
  close,
  province,
  dataAllProvince,
  handleChangDataForReturn,
}) {
  const [api, contextHolder] = notification.useNotification();
  const [filterDates, setFilterDates] = useState({});
  const [filterDistrict, setFilterDistrict] = useState(null); // อำเภอ
  const [filterContractId, setFilterContractId] = useState(""); // เลขสัญญา
  const userI = localStorage.getItem("USER_ID");
  const [loading, setLoading] = useState(true);
  const [selectedProvince, setSelectedProvince] = useState([]);
  const [dataForSubmit, setDataForSubmit] = useState(dataAllProvince);

  // console.log("province", province);
  // console.log("selectedProvince", selectedProvince);
  // console.log("dataForSubmit", dataForSubmit);
  // console.log("filterDates", filterDates);
  // console.log("dataAllProvince", dataAllProvince);

  useEffect(() => {
    let filtered = dataAllProvince?.filter((contract) => {
      const matchProvince = province
        ? contract.provinceName === province
        : true;
      const matchDistrict = filterDistrict
        ? contract.districtName === filterDistrict
        : true;
      const matchContno = filterContractId
        ? contract.contno.includes(filterContractId)
        : true;
      return matchProvince && matchDistrict && matchContno;
    });

    // group เป็น province -> district -> contracts
    const groupedResult = filtered.reduce((acc, item) => {
      if (!acc[item.provinceName]) acc[item.provinceName] = {};
      if (!acc[item.provinceName][item.districtName])
        acc[item.provinceName][item.districtName] = [];
      acc[item.provinceName][item.districtName].push(item);
      return acc;
    }, {});
    setSelectedProvince(groupedResult[province]);
  }, [province, dataAllProvince, filterDistrict, filterContractId]);

  const columns = [
    {
      title: "ชื่อ",
      align: "center",
      render: (value) => {
        // console.log("value", value);
        return (
          <>
            {value ? (
              <div style={{ textAlign: "start" }}>
                {value?.SNAM} {value?.NAME1} {value?.NAME2}
              </div>
            ) : null}
          </>
        );
      },
    },
    {
      title: "ที่อยู่",
      dataIndex: "asset",
      key: "asset",
      align: "center",
      render: (addresses) => {
        if (!addresses || addresses.length === 0) return null;
        // console.log("addresses", addresses);

        return (
          <div
            style={{
              // display: 'flex',
              flexDirection: "column",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "8px",
            }}
          >
            {addresses.map((addr, idx) => {
              // console.log("addr", addr);
              const addressText = addr ? (
                <>
                  {addr?.numberLand ? addr?.numberLand : ""}
                  {addr?.numberLandlawang ? addr?.numberLandlawang : ""}
                  {addr?.district ? addr?.district : ""}
                  {addr?.subdistrict ? addr?.subdistrict : ""}
                  {addr?.zipcode ? addr?.zipcode : ""}
                </>
              ) : (
                addr.address
              );

              const lat = addr.lat || null;
              const lng = addr.lng || null;

              return <span>{addressText}</span>;
            })}
          </div>
        );
      },
    },
    {
      title: "เบอร์โทร",
      dataIndex: "phone",
      key: "phone",
      align: "center",
      render: (record) => {
        // console.log("record", record);
        return (
          <>
            <div style={{ textAlign: "start" }}>
              {record === 0 ? <>คนกู้</> : <>คนค้ำ {record}</>}
            </div>
          </>
        );
      },
    },
    {
      title: "เกี่ยวข้องกับสัญญา",
      dataIndex: "role",
      key: "role",
      align: "center",
      render: (record) => {
        // console.log("record", record);
        return (
          <>
            <div style={{ textAlign: "start" }}>
              {record === 0 ? <>คนกู้</> : <>คนค้ำ {record}</>}
            </div>
          </>
        );
      },
    },
    {
      title: "สถานะสืบออนไลน์",
      dataIndex: "investigation",
      key: "investigation",
      align: "center",
      render: (value) => (value ? "เจอ" : "ไม่เจอ"),
    },
  ];

  const handdleClose = () => {
    close(false);
  };
  const handleSubmit = async () => {
    if (!filterDates) {
      api.warning({
        // message: 'คำเตือน',
        description: "กรุณาเลือกวันที่ลงพื้นที่",
        placement: "top",
      });
      return;
    }

    if (Object.keys(filterDates).length === 0) {
      api.warning({
        description: "กรุณาเลือกวันที่ลงพื้นที่",
        placement: "top",
      });
      return;
    }
    const UID = 888;
    const params = [];
    Object.entries(selectedProvince).forEach(([district, contracts]) => {
      const dateRound = filterDates[district]
        ? filterDates[district].toISOString()
        : null;
      if (!dateRound) return;
      const transformedContracts = contracts.map((contract) => ({
        dateRound: dateRound,
        loanId: contract.loanId,
        contno: contract.contno,
        district: contract.district,
        province: contract.province,
        customerList: contract.customerList.map((c) => ({
          ...c,
        })),
      }));

      params.push({
        userId: UID,
        data: transformedContracts,
      });
    });
    console.log("params", params);

    try {
      setLoading(true);
      const response = await axios.post(
        POST_ADD_ASSETTHASLOAN,
        params,
        // "http://localhost:8080/api-inv/add-assethasloan", params,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
          },
        }
      );

      console.log("✅ API Response:", response.data); // log ข้อมูลที่ได้กลับมา
      api.success({
        // ✅ แสดงข้อความเมื่อสำเร็จ
        message: "สำเร็จ",
        description: "บันทึกข้อมูลเรียบร้อยแล้ว",
        placement: "top",
      });
      handdleClose();
      handleChangDataForReturn(true); // ส่งข้อมูลกลับไปยัง component หลัก
    } catch (error) {
      console.error("❌ API Error:", error);
      api.error({
        message: "เกิดข้อผิดพลาด",
        description: error.message,
        placement: "top",
      });
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <div style={{ textAlign: "center" }}>
          รายละเอียดพื้นที่จังหวัด ( {province} )
        </div>
      }
      open={open} // แก้จาก visible เป็น open (AntD v5+)
      onCancel={handdleClose}
      width={900}
      footer={[
        <Button key="close" onClick={handdleClose}>
          ปิด
        </Button>,
        <Button key="save" type="primary" onClick={handleSubmit}>
          บันทึก
        </Button>,
      ]}
    >
      <Row justify={"center"}>
        <Col span={24}>
          <Collapse
            accordion
            expandIconPosition="start" // เอา icon มาวางซ้าย
            expandIcon={({ isActive }) => (
              <CaretRightOutlined
                style={{
                  fontSize: "24px",
                  color: "#5e6317",
                  transition: "transform 0.2s",
                  transform: isActive ? "rotate(90deg)" : "rotate(0deg)",
                  lineHeight: "60px", // ให้สูงเท่ากับ header
                  marginTop: "10px",
                }}
              />
            )}
          >
            {Object.entries(selectedProvince).map(([district, contracts]) => (
              <Panel
                // header={`อำเภอ: ${district}`}
                header={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "50%",
                      fontSize: "16px",
                      marginTop: "2px",
                      fontWeight: "500",
                    }}
                  >
                    <span>{district}</span>
                  </div>
                }
                key={district}
                extra={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      lineHeight: "30px",
                      width: "100%",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span style={{ fontSize: "16px" }}>
                      วันที่จะลงพื้นที่ :
                    </span>
                    <DatePicker
                      value={filterDates[district] || null} // เก็บ dayjs object
                      onChange={(date) => {
                        setFilterDates((prev) => ({
                          ...prev,
                          [district]: date || null, // เก็บ dayjs object ไม่ต้องแปลงเป็น ISO string
                        }));
                      }}
                      style={{ width: "50%" }}
                      placeholder="เลือกวันที่ลงสืบทรัพย์"
                      allowClear
                    />
                  </div>
                }
              >
                <Collapse accordion>
                  {contracts?.map((contract) => (
                    <Panel
                      header={`สัญญา: ${contract.contno}`}
                      key={contract.key}
                    >
                      <List.Item
                        style={{
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Table
                          style={{ width: "100%" }}
                          dataSource={contract.customerList}
                          rowKey={(party) => party.name} // ใช้ name เป็น key หรือใช้ field ที่ unique
                          pagination={false} // ปิด pagination เพราะมีแค่ 3 parties
                          bordered
                          size="small"
                          columns={columns}
                        />
                      </List.Item>
                    </Panel>
                  ))}
                </Collapse>
              </Panel>
            ))}
          </Collapse>
        </Col>
      </Row>
      {contextHolder}
    </Modal>
  );
}

export default ModalAddBeforeLawsuitforProvince;
